import { useEffect, useState } from "react";
import { AchievementChecklistSliceAPI } from "../../../../../Redux/DailyWorkChecklistProgress/AchievementChecklistSlice/AchievementChecklistSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context";
import ViewURL from "../../../../../Components/ViewURL/ViewURL";
import { Loading } from "../../../../../Helper/Loading";

export const CheckListModal = (props) => {
    const {
        ChecklistData,
        type,
        handleCloseChecklistModal,
        M_FinancialYearID,
        M_MonthID,
        Flag,
    } = props;
    // console.log(type, "type");

    const { m_AssetID, m_AssetTypeID } = ChecklistData;

    // const { m_WardID, m_UserID } = officerData;
    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user;
    // console.log(UserID)
    const dispatch = useDispatch();

    const [ImageHeading, setImageHeading] = useState("");
    const [showImagePopup, setshowImagePopup] = useState(false);
    const [ImagePopUpData, setImagePopUpData] = useState("");

    const handleShowImage = (img) => {
        setshowImagePopup(true);
        setImagePopUpData(img);
    };

    useEffect(() => {
        const data = {
            M_FinancialYearID: M_FinancialYearID,
            M_MonthID: M_MonthID,
            T_KPIUploadDailyWorkID: ChecklistData?.t_kpiUploadDailyWorkID || 0,
            M_AssetID: m_AssetID,
            M_AssetTypeID: 0,
            Flag: Flag,
            M_ZoneID: 0,
            M_AssetTypeID: m_AssetTypeID,
            M_WorkTypeID: 0,

            M_UserID: UserID,
            token: token,
        };
        dispatch(AchievementChecklistSliceAPI({ data }));
    }, []);

    const { tableData, isLoading } = useSelector(
        (state) => state.AchievementChecklistSliceSliceReducerData
    );

    return (
        <>
            <div
                className="modal fade show zIndex"
                style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#00000090",
                }}
            >
                <div
                    className={`modal-dialog modal-dialog-scrollable ${type === "complete" ? "modal-xl" : "modal-lg"
                        }`}
                    role="document"
                >
                    <div
                        className="modal-content modal-dialog-scrollable p-3"
                        style={{ height: "75vh", width: "90vw" }}
                    >
                        <div className="modal-header py-3">
                            <h5 className="card-title heading_modal">Asset Checklist</h5>

                            <button
                                onClick={() => handleCloseChecklistModal()}
                                type="button"
                                className="btn-close mr-3 mt-2 "
                                data-dismiss="modal"
                                aria-label="Close"
                                data-backdrop="static"
                                style={{ color: "white" }}
                            />
                        </div>
                        {isLoading && <Loading />}

                        <div className="modal-body w-100 mx-0 py-0 overflow-auto">
                            <div className="row border-bottom pb-4 ">
                                <div className="col-12 mb-3">
                                    <table id="" className="table table-bordered mb-1">
                                        <thead className="" id="">
                                            <tr className="text-center">
                                                {type === "complete" ? (
                                                    <>
                                                        <th
                                                            className="text-center fw-bold fs-6"
                                                            style={{ background: "#048a8b" }}
                                                        >
                                                            Sr. No.
                                                        </th>
                                                        <th
                                                            className="text-center fw-bold fs-6"
                                                            style={{ background: "#048a8b" }}
                                                        >
                                                            Checklist Name
                                                        </th>
                                                        <th
                                                            className="text-center fw-bold fs-6"
                                                            style={{ background: "#048a8b" }}
                                                        >
                                                            Yes
                                                        </th>
                                                        <th
                                                            className="text-center fw-bold fs-6"
                                                            style={{ background: "#048a8b" }}
                                                        >
                                                            No
                                                        </th>
                                                        <th
                                                            className="text-center fw-bold fs-6"
                                                            style={{ background: "#048a8b" }}
                                                        >
                                                            Photo
                                                        </th>
                                                        <th
                                                            className="text-center fw-bold fs-6"
                                                            style={{ background: "#048a8b" }}
                                                        >
                                                            Remark
                                                        </th>
                                                    </>
                                                ) : (
                                                    <>
                                                        <th
                                                            className="text-center fw-bold fs-6 "
                                                            style={{ width: "4em", background: "#048a8b" }}
                                                        >
                                                            Sr. No.
                                                        </th>
                                                        <th
                                                            className="text-center fw-bold fs-6"
                                                            style={{ background: "#048a8b" }}
                                                        >
                                                            Checklist Name
                                                        </th>
                                                    </>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableData && tableData.length > 0 ? (
                                                tableData.map((item, idx) => (
                                                    <tr key={idx}>
                                                        {type === "complete" ? (
                                                            <>
                                                                <td className="text-center">{idx + 1}</td>
                                                                <td>
                                                                    {item?.m_Daily_Work_CheckList
                                                                        ? item?.m_Daily_Work_CheckList
                                                                        : "-"}
                                                                </td>
                                                                <td>{item?.m_Daily_Work_CheckList_YesID ? "Yes" : "-"}</td>
                                                                <td>{item?.m_Daily_Work_CheckList_NoID ? "No" : "-"}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {item.checkListPhoto == null ? (
                                                                        <span>-</span>
                                                                    ) : (
                                                                        <>
                                                                            <i
                                                                                className="fa-solid fa-eye"
                                                                                title="View"
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    alignItems: "center",
                                                                                }}
                                                                                onClick={() => (
                                                                                    handleShowImage(item.checkListPhoto),
                                                                                    setImageHeading("Checklist Photo")
                                                                                )}
                                                                            ></i>
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td>{item?.remark ? item?.remark : "-"}</td>
                                                            </>

                                                        ) : (
                                                            <>
                                                                <td className="text-center">{idx + 1}</td>
                                                                <td>
                                                                    {item?.m_Daily_Work_CheckList
                                                                        ? item?.m_Daily_Work_CheckList
                                                                        : "-"}
                                                                </td>
                                                            </>
                                                        )}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="2" className="text-center">
                                                        No Data Available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showImagePopup ? (
                <ViewURL
                    Heading={ImageHeading}
                    setshowImagePopup={setshowImagePopup}
                    ImagePopUpData={ImagePopUpData}
                />
            ) : (
                ""
            )}
        </>
    );
};
